import isurveys from './modules/i-surveys'
import base from './modules/base'
import meeting from './modules/meeting'
export default [
  ...base,
  ...meeting,
  isurveys,
]